import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Alert } from "reactstrap";
import RequestContext from '../../context/RequestContext';

const MessageWithHiddenContent = (props) => {
  const { message, hiddenMessage } = props;
  const [showMessage, setShowMessage] = useState(false);

  return (
    <div>
      <p>
        {message}
        &nbsp;
        <a
          onClick={() => setShowMessage(!showMessage)}>Mostrar {showMessage ? 'menos' : 'mais'}
        </a>
      </p>
      { showMessage && <p>{hiddenMessage}</p>}
    </div>

  );
};

const RequestInfoAlert = (props) => {
  const { color, expires, hiddenMessage, message } = props;
  const requestContext = useContext(RequestContext);

  useEffect(() => {
    if (expires) {
      setTimeout(() => {
        requestContext.setAlertContent({});
      }, expires);
    }
  }, []);

  return (
    <Alert color={color}>
      {
        hiddenMessage
          ? <MessageWithHiddenContent message={message} hiddenMessage={hiddenMessage} />
          : <span>{message}</span>
      }
    </Alert>
  );
};

RequestInfoAlert.propTypes = {
  color: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  hiddenMessage: PropTypes.string,
  expires: PropTypes.number
};

export default RequestInfoAlert;